module.exports = __webpack_public_path__ + "img/details-creative.png?140cdecefeebe401d33b6a2b138c74fa";